import type { FC } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Colors from 'src/core/utils/Colors';
import Fonts from 'src/core/utils/Fonts';
import Dimens from 'src/core/utils/Dimens';

interface Props {
	label: string | undefined;
	value: string | undefined;
	last?: boolean;
}

const InfoItem: FC<Props> = ({ label, value, last = false }: Props) => {
	return (
		<View style={[styles.row, { marginBottom: last ? Dimens.padding0 : Dimens.padding8 }]}>
			<Text style={[styles.label, styles.half]}>{label}</Text>
			<Text style={[styles.value, styles.half]}>{value}</Text>
		</View>
	);
};

export default InfoItem;

const styles = StyleSheet.create({
	row: {
		flexDirection: 'row',
	},
	half: {
		width: '50%',
	},
	label: {
		fontFamily: Fonts.barlow,
		fontSize: Dimens.fontSize16,
		lineHeight: Dimens.lineHeight24,
		color: Colors.gray550,
	},
	value: {
		fontFamily: Fonts.barlowMedium,
		fontSize: Dimens.fontSize16,
		lineHeight: Dimens.lineHeight24,
		color: Colors.gray750,
	},
});
